import EditProductUserModal from './EditProductUserModal'
export default EditProductUserModal
